export default function EarlyQuaddieField() {
  return <span>Coming soon</span>;
}
